export default __webpack_public_path__ + "static/media/wineblue.c93a4a91.jpg";